import DownloadIcon from '@mui/icons-material/Download';
import {
  Box,
  Button,
  Grid,
  Radio,
  TextField,
  Typography,
  Autocomplete,
  Chip,
  ListItem,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs';
import { compile } from 'handlebars/dist/handlebars';
import { isEmpty } from 'lodash-es';
import { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import {
  getJobById,
  getRtrTemplateByTemplateId,
  IJob,
  InformationReqResponse,
  InformationRtrCategoryDTO,
  inviteShareCandidateUsersByInformation,
  sendInformationReq,
  getAllResponses,
  getRecruiterSMTPAccounts,
  ISMTPAccountsResponse,
  getPresignedURLForGet,
  ICandidate,
  getInfoTemplateMappingsByJobIds,
} from 'wisestep-api';
import {
  ChatBoxHeader,
  EmptyTeamsAndUsersIcon,
  IConversationState,
  Label,
  ScrollableTabs,
  TabTextVariant,
  WsButton,
  WsColors,
  WsDialog,
  WsTypoColors,
  WsTypoVariants,
  WsTypography,
  formattedDateISO,
} from 'wisestep-base';

import { DrawerFooter } from '../../../components/filters/components/AdvanceFilterFooterBar';
import { useSurveyLogoUrl } from '../../../components/SurveyBuilder/SurveyCommonMethods';
import { useWorkspaceContext } from '../../../context/WorkspaceContext';
import SubmissionCandidateEvalutationView from '../../../features/conversationWidget/components/SubmissionCandidateEvalutationView';
import { useWorkAssignmentFromJobId } from '../../../features/jobs/listing/hooks';
import { data } from '../../../features/nativeSearch/components/data';
import { failed, success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';
import IInformationRequestJobMapping from '../types/IInformationRequestJobMapping';
import IMappingFormState from '../types/IMappingFormState';
import {
  candidatePlaceholderMap,
  generateRandomUUId,
  resolveCustomPlaceholders,
  rtrAmplitudeEvents,
} from '../utils/rtrHelper';
import { saveMapping } from '../utils/saveMapping';

import DefaultEmailModal from './DefaultEmailModal';
import EditCandidateDrawer from './EditCandidateDrawer';
import RtrEditor from './RtrEditor';

interface IComponentProps {
  state: IConversationState;
  closeWidgetDrawer: () => void;
  isUnifiedView?: boolean;
  minHeight?: string;
  isMapping?: boolean;
  onRtrRequested?: () => void;
}

interface IRecruiterDetails {
  firstName: string;
  lastName?: string;
  email: string;
}

interface IScrollableTab {
  tabName: string;
}

interface survayResponseData {
  ques: string;
  ans: string;
}

type StringToString = {
  [name: string]: string;
};

const RTR_STATUS = {
  RTR_ACCEPTED: 'RTR Accepted',
  RTR_EXPIRED: 'RTR Expired',
  RTR_REQUESTED: 'RTR Requested',
  RTR_REJECTED: 'RTR Rejected',
  RTR_CANCELLED: 'RTR Cancelled',
};

const SendRtrComponent = ({
  state,
  closeWidgetDrawer,
  isUnifiedView = false,
  minHeight = '100vh',
  isMapping = true,
  onRtrRequested,
}: IComponentProps) => {
  const navigate = useNavigate();
  const onWidgetClose = useConversationWidgetStore((state) => state.onWidgetClose);
  const [candidate, setCandidate] = useState<ICandidate>(state.candidate);
  const [loading, setLoading] = useState<boolean>(true);
  const [tabPanelPage, setTabPanelPage] = useState<number>(0);
  const [tabList, setTabList] = useState<IScrollableTab[]>([]);
  const [survey, setSurvey] = useState<Model>();
  const [questionAnswers, setQuestionAnswers] = useState<survayResponseData[]>();
  const [informationResponeTaggedId, setinformationResponeTaggedId] = useState<string>('');
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [previewRtr, setPreviewRtr] = useState<boolean>(false);
  const [job, setJob] = useState<IJob>();
  const [rtrStatus, setRtrStatus] = useState<string>('RTR_NOT_MAPPED');
  const [infoReqResponse, setInfoReqResponse] = useState<InformationReqResponse>();
  const [rtrDescription, setRtrDescription] = useState<string | null>('');
  const [defaultSmtpEmail, setDefaultSmtpEmail] = useState<string | undefined>('');
  const [preferredProviderId, setPreferredProviderId] = useState<string | undefined>('');
  const [hasInformationTemplate, setHasInformationTemplate] = useState<boolean>(false);
  const [showEmailPopup, setShowEmailPopup] = useState<boolean>(false);
  const [showEditCandidate, setShowEditCandidate] = useState<boolean>(false);
  const [selectedPlaceholders, setSelectedPlaceholders] = useState<StringToString>({});
  const [changeCount, setChangeCount] = useState<number>(0);
  const [proceedWithoutPlaceholders, setProceedWithoutPlaceholders] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const fileUrlValue = useSurveyLogoUrl();
  const workspace = useWorkspaceContext();
  const [emailOptions, setEmailOptions] = useState<string[]>([
    state.candidate.email,
    ...(state.candidate.alternateEmails || []),
  ]);
  const [selectedEmail, setSelectedEmail] = useState<string | null>(state.candidate.email);
  const [informationTemplateMappings, setInformationTemplateMappings] = useState<
    IInformationRequestJobMapping[]
  >([]);
  const [selectedTemplate, setSelectedTemplate] = useState<IInformationRequestJobMapping | null>(
    null
  );
  const [showInformationTemplateSelection, setShowInformationTemplateSelection] =
    useState<boolean>(false);

  const activityConversation = useConversationWidgetStore((state) => state.activityConversation);

  const [formState] = useState<IMappingFormState>({
    resumeURl: null,
    openCvView: false,
    candidateInfo: activityConversation ?? state.candidate,
    candidateResumes: [],
    disableSubmit: false,
    results: [],
    actions: [],
    jobForUpdate: null,
  });

  const objectRTRRequested = {
    downloadSource: 'NOT_SPECIFIED',
    recruiterActivity: {
      actions: ['RTR Requested'],
      results: [],
    },
  };

  const [emailError, setEmailError] = useState<string | null>(null);
  const [isEditable, setIsEditable] = useState(false);
  const extendedEmailOptions = [...emailOptions, 'Add Email Address'];

  const workAssignment = useWorkAssignmentFromJobId(job?.id ?? '');

  const validateEmail = (email: string | null) => {
    if (!email) {
      return 'Email cannot be blank';
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Invalid email format';
    }
    return null;
  };

  useEffect(() => {
    (async () => {
      try {
        const smtpResponse = await getRecruiterSMTPAccounts();
        if (smtpResponse && smtpResponse.data) {
          const allEmails: ISMTPAccountsResponse[] = smtpResponse.data;
          let defaultEmail = allEmails.find((email) => email.isDefault);
          if (allEmails?.length === 0) {
            setShowEmailPopup(true);
          } else if (!defaultEmail) {
            defaultEmail = allEmails[0];
          }
          setDefaultSmtpEmail(defaultEmail?.fromEmail);
          setPreferredProviderId(defaultEmail?.id);
        }
      } catch (error) {
        console.error('Error fetching SMTP accounts:', error);
      }
    })();
  }, []);

  const resolveRtrTemplate = (templateHtml: string): string => {
    const formattedHtml = resolveCustomPlaceholders(templateHtml, candidate, job);
    const template = compile(formattedHtml);
    const recruiter: IRecruiterDetails = {
      email: candidate.recruiterId ?? '',
      firstName: candidate.recruiterName ?? '',
    };

    return template({
      candidate: candidate,
      job: job,
      recruiter,
    })
      .replace(/&amp;nbsp;/g, ' ')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  };

  useEffect(() => {
    const fetchJobData = async () => {
      const jobId = state.candidate.jobId as string;
      if (jobId) {
        const jobResponse = await getJobById(jobId);
        setJob(jobResponse.data);
      }
    };

    fetchJobData();
  }, [state.candidate.jobId]);

  const extractKey = (str: string): string | null => {
    const match = str.match(/{{candidate\.([^.}]+)/);
    return match ? match[1] : null;
  };

  const checkForMissingPlaceholders = (rtrDescription: string) => {
    try {
      const allPlaceholders = rtrDescription.match(/{{candidate\.[^}]+}}/g);
      const placeholderAvailability: StringToString = {};
      const allCandPlaceHolderMap = candidatePlaceholderMap;
      allPlaceholders?.forEach((placeholder) => {
        if (allCandPlaceHolderMap[placeholder]) {
          placeholderAvailability[allCandPlaceHolderMap[placeholder][0]] =
            extractKey(placeholder) ?? '';
        }
      });
      setSelectedPlaceholders(placeholderAvailability);
      setShowEditCandidate(true);
    } catch (error) {
      console.error(error);
      setNotification(warning('Some fields are not available'));
    }
  };

  useEffect(() => {
    (async () => {
      if (job) {
        const response = await getInfoTemplateMappingsByJobIds([job?.id as string]);
        if (response && response.data) {
          const availableTemplates: IInformationRequestJobMapping[] =
            response.data[job?.id as string];
          const rtrTemplates = availableTemplates.filter((template) => template.hasRtr);
          setInformationTemplateMappings(rtrTemplates);
          if (rtrTemplates?.length === 1) {
            setSelectedTemplate(rtrTemplates[0]);
          } else if (rtrTemplates?.length > 1) {
            setShowInformationTemplateSelection(true);
            setLoading(false);
          } else {
            setRtrStatus('RTR_NOT_MAPPED');
            setLoading(false);
          }
        }
      }
    })();
  }, [job]);

  useEffect(() => {
    const fetchData = async () => {
      const interactionId = state.candidate.candidateId as string;
      const jobId = state.candidate.jobId as string;
      const teamId = workAssignment?.team?.id ?? '';

      if (jobId && job) {
        const rtrResponse = await getRtrTemplateByTemplateId(
          selectedTemplate?.templateId as number
        );
        if (rtrResponse && rtrResponse.data) {
          setRtrDescription(resolveRtrTemplate(rtrResponse.data?.rtrTemplate?.body['body']));
          initializeSurvey(rtrResponse.data);
          if (interactionId) {
            const response = await getAllResponses(
              interactionId + '_' + jobId,
              jobId,
              defaultSmtpEmail ?? '',
              teamId
            );
            if (response.data && response.data?.length > 0) {
              const infoReqResp = response.data.find(
                (ir) =>
                  ir.informationReqTemplate?.id === rtrResponse.data?.informationCategoryId &&
                  jobId === ir.jobId
              );
              setinformationResponeTaggedId(infoReqResp.id);
              if (infoReqResp.response !== null) {
                const keys = Object.keys(infoReqResp.response);
                const feedbackArray = keys.map((ques) => ({
                  ques,
                  ans: infoReqResp.response[ques].toString(),
                }));
                setQuestionAnswers(feedbackArray);
              }
              if (
                infoReqResp &&
                infoReqResp.sendRequest &&
                infoReqResp.rtrFeedback !== RTR_STATUS.RTR_CANCELLED
              ) {
                setInfoReqResponse(infoReqResp);
                setRtrStatus(infoReqResp.rtrFeedback ?? 'RESPONSE_PENDING');
              } else {
                checkForMissingPlaceholders(rtrResponse.data?.rtrTemplate?.body['body']);
                setRtrStatus('NOT_SENT');
              }
            } else {
              checkForMissingPlaceholders(rtrResponse.data?.rtrTemplate?.body['body']);
              setRtrStatus('NOT_SENT');
            }
          }
        } else {
          setRtrStatus('RTR_NOT_MAPPED');
        }
        setLoading(false);
      }
    };

    const initializeSurvey = (informationTemplateData: InformationRtrCategoryDTO) => {
      const allowedTabList: IScrollableTab[] = [];
      allowedTabList.push({ tabName: 'RTR Template' });
      if (!isEmpty(informationTemplateData.category)) {
        setHasInformationTemplate(true);
        allowedTabList.push({ tabName: 'Information Request' });
      }
      setTabList(allowedTabList);

      const surveyModel = new Model(JSON.stringify(informationTemplateData?.category));
      setSurvey(surveyModel);

      if (infoReqResponse) {
        setQuestionAnswers(infoReqResponse.response);
      }
    };

    if (defaultSmtpEmail && selectedTemplate) {
      fetchData();
    }
  }, [job, candidate, changeCount, defaultSmtpEmail, selectedTemplate, workAssignment]);

  const fullUrl = `${window.location.href}&corphiringTemplate=informationrequestTemplate`;

  const handleSubmitRtr = async (data) => {
    setIsLoading(true);
    try {
      if (data) {
        const emailRefId = generateRandomUUId();
        await inviteShareCandidateUsersByInformation({
          subject: `Information Required for ${''}`,
          body: data.description,
          interactionId: state.candidate.candidateId as string,
          jobId: state.candidate.jobId as string,
          sharedCandidateName: state.candidate.name,
          sharedJobTitle: state.candidate.mappedJobTitle as string,
          sharedJobLocation: state.candidate.mappedJobLocation as string,
          sharedCandidateEmail: selectedEmail || candidate.email,
          sharedJobCode: state.candidate.jobCode as string,
          informationTemplateId: informationResponeTaggedId,
          isRTR: true,
          recruiterEmail: defaultSmtpEmail ?? '',
          logoUrl: fileUrlValue ?? '',
          isMapping: false,
          otherInfo: [{ candidateProfileLink: fullUrl }],
          informationReqResponseId: infoReqResponse?.id ? infoReqResponse?.id.toString() : '',
          preferredProviderId: preferredProviderId,
          emailRefId: emailRefId,
        });
        await sendInformationReq({
          id: informationResponeTaggedId,
          mappingInteractionId: state.candidate.id as string,
          rtrDescription: {
            rtrDescriptionValue: rtrDescription ?? '',
            candidateName: candidate.name,
            candidateEmail: selectedEmail || candidate.email,
          },
          emailRefId: emailRefId,
        });
        if (formState.candidateInfo) {
          formState.candidateInfo.createdOn = formattedDateISO(new Date());
        }
        formState.candidateInfo &&
          (await saveMapping(objectRTRRequested, formState.candidateInfo, job ? job : {}));
        setNotification(success(' Information request sent to candidate!'));
        setRtrStatus('RESPONSE_PENDING');
        rtrAmplitudeEvents('rtr_request', 'RTR request sent to candidate', workspace);
        if (onRtrRequested) {
          onRtrRequested();
        }
        if (isUnifiedView) {
          closeWidgetDrawer();
        }
      }
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      setNotification(failed('Unable to send RTR request'));
      setIsLoading(false);
    }
  };

  const removeQueryParams = (url: string) => {
    const urlObj = new URL(url);
    urlObj.search = '';
    return urlObj.toString();
  };

  const downlodPdf = async () => {
    if (infoReqResponse) {
      const data = await getPresignedURLForGet({
        fileName: infoReqResponse.responsePdfUrl
          ? removeQueryParams(infoReqResponse.responsePdfUrl)
          : '',
      });
      if (data) {
        const link = document.createElement('a');
        link.download = 'candidateResponse.pdf';
        link.href = data.data.preSignedUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const updateCandiate = (updatedCandidate: ICandidate, proceed: boolean) => {
    setProceedWithoutPlaceholders(proceed);
    setRtrDescription(null);
    setCandidate((prevCandidate) => ({ ...prevCandidate, ...updatedCandidate }));
    setChangeCount(changeCount + 1);
    setPreviewRtr(true);
  };

  const handleEmailChange = (event: React.ChangeEvent<any>, value: string | null) => {
    setEmailError(null);
    if (value === 'Add Email Address') {
      value = '';
      setSelectedEmail('');
    }
    const error = validateEmail(value);
    if (error) {
      setEmailError(error);
    } else {
      if (value && !emailOptions.includes(value)) {
        setEmailOptions([...emailOptions, value]);
      }
      setSelectedEmail(value);
      setEmailError(null);
    }
  };

  const handleEmailValidation = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    const error = validateEmail(event.target.value);
    if (error) {
      setEmailError(error);
    } else {
      setEmailError(null);
    }
  };

  return (
    <>
      {showInformationTemplateSelection && (
        <>
          <ChatBoxHeader>
            <Grid container>
              <Grid item xs={12}>
                <Box mt={1}>
                  <WsTypography
                    variant={WsTypoVariants.TITLE}
                    color={WsTypoColors.PRIMARY}
                    bold={true}
                  >
                    Select RTR Template
                  </WsTypography>
                </Box>
              </Grid>
            </Grid>
          </ChatBoxHeader>
          <Grid container spacing={2} sx={{ p: 2 }}>
            {informationTemplateMappings.map((template) => (
              <Grid item xs={12} key={template.id}>
                <Box
                  p={2}
                  border={1}
                  borderColor={
                    selectedTemplate?.id === template.id
                      ? WsColors.TheBlues500
                      : WsColors.BorderGrey
                  }
                  borderRadius={1}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      borderColor: WsColors.TheBlues500,
                    },
                  }}
                  onClick={() => {
                    setLoading(true);
                    setSelectedTemplate(template);
                    setShowInformationTemplateSelection(false);
                  }}
                >
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Radio
                        checked={selectedTemplate?.id === template.id}
                        onChange={() => {
                          setLoading(true);
                          setSelectedTemplate(template);
                          setShowInformationTemplateSelection(false);
                        }}
                      />
                    </Grid>
                    <Grid item xs>
                      <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.PRIMARY}>
                        {template.templateName}
                      </WsTypography>
                      <Grid container spacing={1}>
                        <Grid item>
                          <WsTypography
                            variant={WsTypoVariants.BODY2}
                            color={WsTypoColors.SECONDARY}
                          >
                            Created on: {dayjs(template.createdOn).format('D MMMM YYYY')}
                          </WsTypography>
                        </Grid>
                        <Grid item>
                          <WsTypography
                            variant={WsTypoVariants.BODY2}
                            color={WsTypoColors.SECONDARY}
                          >
                            Created by: {template.createdBy}
                          </WsTypography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            ))}
          </Grid>
        </>
      )}
      {(!showEditCandidate || proceedWithoutPlaceholders) &&
        (rtrStatus === 'NOT_SENT' || rtrStatus === 'RTR Expired' || previewRtr) && (
          <Box flexDirection="column" display="flex" minHeight={minHeight}>
            <Box flex={1} overflow="auto">
              <ScrollableTabs
                variant={TabTextVariant.SUB_TITLE}
                scrollList={tabList}
                getTabIndex={(index: number) => setTabPanelPage(index)}
                defaultValue={tabPanelPage}
              />
              {previewRtr && tabPanelPage == 0 && (
                <Grid container justifyContent="space-between" sx={{ px: 2, pt: 1 }}>
                  <Grid item mr={2} display="flex" gap={1}>
                    <Label>Recipient Email : </Label>
                    <Autocomplete
                      value={selectedEmail || ''}
                      onChange={(event, newValue) => {
                        if (newValue === 'Add Email Address') {
                          setIsEditable(true);
                          handleEmailChange(event, newValue);
                        } else {
                          setIsEditable(false);
                          handleEmailChange(event, newValue);
                        }
                      }}
                      options={extendedEmailOptions}
                      disableClearable
                      freeSolo={isEditable}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          error={!!emailError}
                          helperText={emailError}
                          disabled={!isEditable}
                          onBlur={(event) => {
                            handleEmailChange(event, event.target.value);
                          }}
                          onChange={handleEmailValidation}
                        />
                      )}
                      renderOption={(props, option) => (
                        <ListItem {...props} disableGutters>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            width="100%"
                          >
                            <WsTypography variant={WsTypoVariants.BODY2}>{option}</WsTypography>
                            {option === state.candidate.email && (
                              <Chip label="Primary" color="primary" size="small" />
                            )}
                          </Box>
                        </ListItem>
                      )}
                    />
                  </Grid>
                  <Grid item>
                    <Button size="large" variant="outlined" onClick={() => setPreviewRtr(false)}>
                      Edit Template
                    </Button>
                  </Grid>
                </Grid>
              )}
              {tabPanelPage == 0 && (
                <>
                  <Box
                    m={2}
                    p={1}
                    border={0.1}
                    borderColor={WsColors.BorderGrey}
                    borderRadius={2}
                    maxHeight={previewRtr ? 600 : 'auto'}
                    overflow="auto"
                  >
                    {previewRtr && rtrDescription ? (
                      <Typography
                        color={WsTypoColors.BLACK}
                        dangerouslySetInnerHTML={{
                          __html: infoReqResponse?.rtrDescription?.rtrDescriptionValue
                            ? infoReqResponse?.rtrDescription?.rtrDescriptionValue
                            : rtrDescription,
                        }}
                      />
                    ) : (
                      <>
                        {rtrDescription && (
                          <RtrEditor
                            rtrDescription={rtrDescription ?? ''}
                            onRtrUpdate={setRtrDescription}
                          />
                        )}
                      </>
                    )}
                  </Box>
                </>
              )}
              {hasInformationTemplate && tabPanelPage == 1 && (
                <Box
                  m={3}
                  p={1}
                  border={0.1}
                  borderColor={WsColors.BorderGrey}
                  borderRadius={2}
                  maxHeight={600}
                  overflow="auto"
                >
                  {survey && <Survey model={survey} />}
                </Box>
              )}
            </Box>
            <DrawerFooter mt={5}>
              <Grid container justifyContent="flex-end" alignItems="center" m={2}>
                <Grid item pr={2}>
                  <WsButton
                    disabled={isLoading || isEmpty(defaultSmtpEmail) || !!emailError}
                    onClick={() => handleSubmitRtr(data)}
                    variant="contained"
                    endIcon={isLoading ? <CircularProgress size={17} color="secondary" /> : <></>}
                  >
                    {isLoading ? 'Sending...' : previewRtr ? 'Request RTR' : 'Save and Request RTR'}
                  </WsButton>
                </Grid>
              </Grid>
            </DrawerFooter>
          </Box>
        )}
      {(rtrStatus === 'RTR Accepted' || rtrStatus === 'RTR Rejected') && (
        <>
          <ChatBoxHeader>
            <Grid container>
              <Grid item xs={3}>
                <Box mt={1}>
                  <WsTypography
                    variant={WsTypoVariants.TITLE}
                    color={WsTypoColors.PRIMARY}
                    bold={true}
                  >
                    View RTR
                  </WsTypography>
                </Box>
              </Grid>
            </Grid>
          </ChatBoxHeader>
          <Grid container>
            <Grid
              container
              item
              xs={12}
              borderBottom={1}
              p={2}
              m={2}
              justifyContent="space-between"
            >
              <Grid item xs={8}>
                <WsTypography
                  variant={WsTypoVariants.SUB_TITLE}
                  color={WsTypoColors.SECONDARY}
                  bold={true}
                >
                  {state.candidate.mappedJobTitle}
                </WsTypography>
              </Grid>
              <Grid item xs={2} container justifyContent="flex-end">
                <WsButton onClick={downlodPdf} startIcon={<DownloadIcon />}>
                  Download RTR
                </WsButton>
              </Grid>
              <Grid item xs={2} container justifyContent="flex-end">
                <WsTypography
                  variant={WsTypoVariants.SUB_TITLE}
                  color={rtrStatus === 'RTR Accepted' ? WsTypoColors.GREEN : WsTypoColors.RED}
                  bold={true}
                >
                  {rtrStatus}
                </WsTypography>
              </Grid>
            </Grid>
            {infoReqResponse?.response && questionAnswers && questionAnswers?.length > 0 && (
              <Grid item xs={12}>
                <SubmissionCandidateEvalutationView feedbackResponseData={questionAnswers} />
              </Grid>
            )}
          </Grid>
        </>
      )}
      {rtrStatus === 'RESPONSE_PENDING' && (
        <>
          <ChatBoxHeader>
            <Grid container>
              <Grid item xs={12}>
                <Box mt={1}>
                  <WsTypography
                    variant={WsTypoVariants.TITLE}
                    color={WsTypoColors.PRIMARY}
                    bold={true}
                  >
                    RTR Sent
                  </WsTypography>
                </Box>
              </Grid>
            </Grid>
          </ChatBoxHeader>
          <Grid container>
            <Grid m={1} container alignItems="center" borderBottom={1} borderColor="#dadada">
              <Grid item xs={6}>
                <Box mt={1} pt={1} pb={1}>
                  <WsTypography
                    variant={WsTypoVariants.SUB_TITLE}
                    color={WsTypoColors.SECONDARY}
                    bold={true}
                  >
                    {job?.title}
                  </WsTypography>
                </Box>
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Box mt={1} pt={1} pb={1}>
                  <WsTypography
                    hoverText="RTR Requested Date"
                    variant={WsTypoVariants.SUB_TITLE}
                    color={WsTypoColors.SECONDARY}
                  >
                    {dayjs(infoReqResponse?.requestedOn).format('hh:mm A, D MMMM YYYY')}
                  </WsTypography>
                </Box>
                <Box mt={1} pl={1.5} pt={1} pb={1}>
                  <WsTypography
                    variant={WsTypoVariants.SUB_TITLE}
                    color={WsTypoColors.YELLOW}
                    bold={true}
                  >
                    Pending Response
                  </WsTypography>
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              item
              display="flex"
              alignItems="flex-end"
              justifyContent="flex-end"
              p={2}
            >
              <Button size="large" variant="outlined" onClick={() => setPreviewRtr(true)}>
                Show Template
              </Button>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Box textAlign="center" pt={20} px={4}>
                {<EmptyTeamsAndUsersIcon />}
                <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.SECONDARY}>
                  {'RTR Request Sent. Awaiting candidate response.'}
                </WsTypography>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
      {rtrStatus === 'RTR_NOT_MAPPED' && !showInformationTemplateSelection && (
        <>
          <ChatBoxHeader>
            <Grid container>
              <Grid item xs={12}>
                <Box mt={1}>
                  <WsTypography
                    variant={WsTypoVariants.TITLE}
                    color={WsTypoColors.PRIMARY}
                    bold={true}
                  >
                    RTR Template
                  </WsTypography>
                </Box>
              </Grid>
            </Grid>
          </ChatBoxHeader>
          <Grid container style={{ height: '90vh' }} justifyContent="center" alignItems="center">
            <Grid item xs={12}>
              <Box textAlign="center" pt={!loading ? 20 : 0} px={4}>
                {!loading ? (
                  <>
                    <EmptyTeamsAndUsersIcon />
                    <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.SECONDARY}>
                      {'No RTR Template is associated with the Job for this candidate.'}
                    </WsTypography>
                    <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
                      {
                        '(To send RTR request to this candidate, kindly associate the RTR Template by editing the current Job)'
                      }
                    </WsTypography>
                  </>
                ) : (
                  <Box display="flex" justifyContent="center" alignItems="center">
                    <CircularProgress />
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </>
      )}
      {showEmailPopup && (
        <WsDialog openDialog={showEmailPopup} onClose={() => setShowEmailPopup(false)}>
          <DefaultEmailModal
            title="Email not configured"
            text="No email is configured for your Wisestep Account."
            content="To configure your email, please click on 'Configure'"
            confirm={() => {
              setShowEmailPopup(false);
              setShowEditCandidate(false);
              navigate('/email-settings');
              closeWidgetDrawer();
              onWidgetClose();
            }}
            close={() => {
              setShowEditCandidate(false);
              setShowEmailPopup(false);
            }}
            confirmButtonText="Configure"
          ></DefaultEmailModal>
        </WsDialog>
      )}
      {!proceedWithoutPlaceholders && !showEmailPopup && showEditCandidate && (
        <EditCandidateDrawer
          candidate={candidate}
          onClose={() => setShowEditCandidate(false)}
          onSubmit={updateCandiate}
          selectedPlaceholders={selectedPlaceholders}
          isMapping={isMapping}
        />
      )}
    </>
  );
};

export default SendRtrComponent;
